module.exports = __webpack_public_path__ + "img/TimeManagement.1f9b5b08.svg";